<template>
  <div>
    <h1>账户实时监控系统Ddemo</h1>
    <button @click="getWebsocket">点击请求后台数据</button>

    <p>{{ dataFromServer }}</p>
    <div id="chart" style="width: 600px; height: 400px;"></div>

  </div>


</template>
<script>
import * as echarts from 'echarts'

export default {
  data() {
    return {
      chartData: [],
      dataFromServer: {}
    }},

      created() { // 页面创建生命周期函数
    this.initWebSocket()
  },
  updated() {
    const chart = echarts.getInstanceByDom(document.getElementById('chart'))
    chart.setOption({
      series: [{
        data: this.chartData
      }]
    })
  },
  destroyed: function () { // 离开页面生命周期函数
    this.websocketclose();
  },
  mounted() {
    const chart = echarts.init(document.getElementById('chart'))
    chart.setOption({
      xAxis: {
        type: 'category',
        data: ['1', '2', '3', '4', '5', '6', '7', '8','9', '10', '11', '12', '13', '14', '15', '16']
      },
      yAxis: {
        type: 'value',
        name:'元'
      },
      series: [{
        data: this.chartData,
        type: 'line'
      }]
    })
  },
  methods: {
    initWebSocket: function () {
      // WebSocket与普通的请求所用协议有所不同，ws等同于http，wss等同于https
      this.websock = new WebSocket("ws://localhost:8088/websocket/DPS007");
      this.websock.onopen = this.websocketonopen;
      this.websock.onerror = this.websocketonerror;
      this.websock.onmessage = this.websocketonmessage;
      this.websock.onclose = this.websocketclose;
    },
    websocketonopen: function () {
      console.log("WebSocket连接成功");
    },
    websocketonerror: function (e) {
      console.log("WebSocket连接发生错误");
      },
    websocketonmessage: function (e) {
      const newData = JSON.parse(event.data)
      this.chartData.push(newData)
      if (this.chartData.length > 16) {
        this.chartData.shift()
      }
      this.dataFromServer = e.data
      console.log(e.data);                // console.log(e);

    },
    websocketclose: function (e) {
      console.log("connection closed (" + e.code + ")");
    },
    getWebsocket:function(){
      let url = "http://127.0.0.1:8088/api/v2/teachStf/import?shipId=DPS007"
      // 这里只是一个基于axios的ajax请求，你可以换成你的请求格式
       this.$axios.get(url)
         }
  }
}

</script>
<!--<style lang="less" scoped>-->
<!--</style>-->





// WEBPACK FOOTER //
// src/components/VivoUserInfo.vue